export enum InvDailyKindEnum {
  Manual = 0,
  Confirm = 1,
  ConfirmedBySima = 2,
  Reject = 3,
}
